import React from "react";
import Chart from "react-apexcharts";
import { Card, CardContent } from "@mui/material";

export default function ReportsLiveChart({ months, chartValue }) {
  const chartOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
    },
    xaxis: {
      categories: months,
      labels: {
        style: { colors: "#787878", fontSize: "14px" },
      },
    },
    yaxis: {
      min: Math.min(...chartValue),
      max: Math.max(...chartValue),
      labels: {
        style: { colors: "#787878", fontSize: "14px" },
      },
    },
    stroke: {
      curve: "smooth",
      width: 3,
      colors: ["#6A0DAD"],
    },
    fill: {
      type: "solid",
      colors: ["#6A0DAD"],
      opacity: 0.15,
    },
    grid: {
      borderColor: "#EAEAEA",
      strokeDashArray: 5,
    },
    dataLabels: {
      enabled: false,
    },
  };

  const chartSeries = [
    {
      name: "Data",
      data: chartValue,
    },
  ];

  return (
    <Card sx={{ p: 2, borderRadius: "12px" }}>
      <CardContent>
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="area"
          height={300}
        />
      </CardContent>
    </Card>
  );
}
